var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileHomePageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 330,
    viewBox: "0 0 393 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.324 212.035C269.091 208.878 264.042 197.097 254.541 192.563C237.183 184.275 218.269 198.81 223.266 218.119C228.329 237.598 250.817 242.379 248.814 258.858C248.07 265.135 247.824 271.293 249.12 277.31H291.37",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.01 152.963C273.633 154.743 266.812 161.489 264.884 172.763C261.466 192.6 283.939 204.142 277.11 219.273C268.51 238.283 267.691 258.984 291.393 277.31L331.648 277.727V174.014C331.648 174.014 326.659 175.183 317.723 172.458C317.723 172.458 317.991 178.556 316.092 181.393C314.193 184.23 309.219 185.727 302.689 184.915L304.007 181.654C302.77 182.251 301.354 182.366 300.038 181.974L306.635 169.069C306.635 169.069 295.771 164.684 287.96 158.004L282.01 152.963Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.654 98.3961L230.303 107.168L223.087 119.328C223.087 119.328 230.653 122.195 232.306 111.256L235.18 110.325L241.882 114.637L216.4 154.251L194.664 140.274C194.664 140.274 198.723 138.577 197.643 131.51C197.643 131.51 212.364 131.942 211.046 122.47L198.976 125.791L216.654 98.3961Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.004 102.7C251.004 102.7 248.859 109.968 248.859 120.877C248.859 131.786 252.441 141.332 257.139 141.332C261.838 141.332 265.42 132.322 265.42 119.864C265.42 107.406 262.687 103.921 262.687 103.921L251.004 102.7Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.284 169.717C186.688 173.828 189.505 177.683 192.691 181.222C197.792 186.799 206.772 192.771 210.101 188.84C213.429 184.908 207.964 173.396 201.217 165.756C197.265 161.235 192.54 157.453 187.263 154.586L184.284 169.717Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327.083 71.1648C324.909 70.4201 322.727 69.4074 321.126 66.5257C316.301 57.6869 322.615 48.3119 324.633 35.9212C325.83 28.2319 325.755 20.3981 324.41 12.7333C324.41 12.7333 323.836 20.686 321.32 22.5773C318.803 24.4687 315.362 23.7166 311.55 22.3242C307.082 20.6785 301.914 18.9733 295.451 21.1774C295.451 21.1774 303.068 0.558472 322.779 0.558472C330.516 0.558472 335.751 3.73062 340.606 9.06965C345.878 14.8704 349.727 17.7968 356.243 18.7871C362.758 19.7775 370.979 24.9378 373.362 32.7639C375.745 40.5901 379.505 43.576 388.433 48.0736C397.362 52.5712 400.348 61.2313 400.348 69.5564C400.348 77.8814 396.155 91.7912 378.336 90.7785C361.589 89.8328 354.724 77.0772 356.317 66.4736L327.083 48.0811V71.1648Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8684 183.426C59.3792 180.723 58.0612 178.511 58.0612 178.511C58.0612 178.511 56.84 182.175 52.6402 179.502C48.4405 176.829 46.147 170.41 49.0511 168.429C51.9552 166.448 56.2294 172.152 56.2294 172.152C54.954 166.52 51.996 161.409 47.748 157.498C47.748 157.498 53.5338 158.012 56.4155 156.366C63.3481 152.412 60.4291 147.311 70.3104 147.088C80.1917 146.864 82.6639 136.812 76.6919 130.535C70.72 124.257 63.7278 127.861 61.4269 130.535C59.3393 133.135 56.5076 135.037 53.3104 135.985C49.9149 137.02 43.1163 136.812 40.5473 141.198C39.4458 143.063 38.8903 145.2 38.9443 147.366C38.9983 149.532 39.6595 151.639 40.8526 153.447C42.9153 156.641 42.811 159.523 41.0611 161.891C39.3113 164.259 37.1518 166.932 37.0476 169.814C36.9433 172.696 38.589 174.647 42.0664 175.265C45.5438 175.883 46.4151 178.243 47.0331 179.465C47.6512 180.686 48.4703 185.973 53.8167 186.911C56.1177 187.313 59.7068 186.271 60.5185 183.545L60.8684 183.426Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.57 95.2016C120.99 95.2016 131.058 85.1334 131.058 72.7136C131.058 60.2939 120.99 50.2256 108.57 50.2256C96.15 50.2256 86.0818 60.2939 86.0818 72.7136C86.0818 85.1334 96.15 95.2016 108.57 95.2016Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.574 22.3391C300.574 22.3391 298.586 31.431 302.063 43.3005C305.414 54.8424 312.384 59.1687 318.103 58.3645",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M309.04 32.7714L308.132 41.357H311.125",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M318.289 30.6119C318.289 30.6119 316.36 33.8213 313.925 30.6119",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.3 31.4385C306.3 31.4385 304.558 34.5436 302.577 31.2449",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M331.648 261.523L285.093 172.152",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.697 194.439L305.719 211.752",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M319.89 238.953L286.977 240.755",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M271.593 241.634L243.17 209.905",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.022 233.004L248.859 232.535",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M252.009 219.772L252.783 207.485",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1111 148.309L106.656 121.495",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9854 143.089L107.825 139.478",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.436 131.83L97.9959 121.636",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M280.015 266.021L264.139 268.009",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M390.876 88.2542L401.956 95.2314",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M303.969 181.579C302.741 182.207 301.314 182.322 300.001 181.899L307.663 166.917L327.083 168.719V48.0886L356.302 66.481",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M309.807 167.111L302.651 184.841C302.651 184.841 309.711 186.092 314.424 182.994C316.8 181.438 317.723 178.526 317.723 172.904",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M312.682 167.379L307.149 185.087",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M315.697 167.662L312.138 184.126",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M161.848 277.652H92.9994",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M291.393 277.235C283.522 271.623 277.428 263.87 273.834 254.896",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M331.648 154.616V187.499",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M327.083 154.616H375.827L335.445 60.5537",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M320.031 63.8525L300.001 98.3887H227.421L225.224 101.993",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M257.139 98.3887C261.711 98.3887 265.42 108.002 265.42 119.864",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M180.74 152.888C178.908 158.637 182.229 168.585 189.675 177.811",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M262.687 103.921L239.678 101.509C239.678 101.509 241.04 109.581 232.336 111.256C232.336 111.256 231.085 121.845 223.117 119.328L232.656 103.184",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M358.521 154.616C361.545 157.855 364.24 160.73 367.733 164.438",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M317.723 72.7136C314.979 80.6632 314.421 89.2039 316.107 97.443C317.596 104.145 319.599 109.357 327.083 119.037",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M257.139 141.332C280.752 141.332 306.851 135.471 317.723 107.585",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M317.723 172.376C328.656 174.727 339.993 174.427 350.786 171.5C361.579 168.573 371.515 163.105 379.763 155.553C388.01 148.001 394.33 138.584 398.194 128.09C402.057 117.595 403.352 106.329 401.971 95.2314C401.537 91.6893 400.827 88.1863 399.849 84.7544",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M231.457 232.766C231.226 233.346 231.003 233.927 230.787 234.501",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M229.595 238C227.656 244.35 226.493 250.91 226.133 257.54C223.579 297.132 248.859 327.535 293.418 329.382C333.055 331.02 369.847 300.721 365.238 253.161C362.26 218.431 363.592 201.863 379.386 186.71C392.544 174.051 408.784 174.364 415.918 175.257",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.97 4.97"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M182.616 214.745C182.75 229.735 177.813 248.254 159.964 257.837",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M199.46 121.182H190.606C190.606 121.182 190.368 122.344 179.399 157.14C168.431 191.937 134.796 220.181 92.0686 210.374C49.3415 200.567 36.4965 196.837 36.4965 196.837L-26.5518 246.333",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M210.101 188.839C210.101 188.839 170.754 243.302 92.9994 221.819V277.667",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 210.873L2.97302 269.796",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M240.802 177.707C248.131 177.707 254.071 171.766 254.071 164.438C254.071 157.109 248.131 151.168 240.802 151.168C233.474 151.168 227.533 157.109 227.533 164.438C227.533 171.766 233.474 177.707 240.802 177.707Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M149.532 146.038C154.776 146.038 159.026 141.787 159.026 136.544C159.026 131.3 154.776 127.05 149.532 127.05C144.289 127.05 140.038 131.3 140.038 136.544C140.038 141.787 144.289 146.038 149.532 146.038Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4763 209.116C18.4763 209.116 -6.79657 196.457 -6.79657 159.523C-6.79657 134.414 8.09613 116.513 30.5767 107.585C56.8251 97.16 79.179 103.906 95.412 91.7465C111.645 79.5866 111.176 58.7517 105.614 48.4757C100.118 38.3413 87.3998 28.7801 70.8465 32.7639C55.7677 36.3903 46.7204 48.1034 45.4024 60.5463",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9994 165.793V107.585",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M192.431 127.608L211.099 122.47C211.099 122.47 213.72 131.086 197.695 131.51C197.695 131.51 199.929 141.473 189.891 141.332L184.292 169.717",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8391 201.32L57.7484 213.911L67.168 204.559L70.2508 216.57L80.9959 207.813",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.168 204.559C66.8898 208.409 65.6284 212.124 63.5044 215.348C60.0717 220.218 58.8504 224.917 60.295 232.535C61.7396 240.152 61.3971 247.584 55.5294 253.883C49.6617 260.183 47.8969 266.349 49.2223 277.652C50.5478 288.956 48.3362 295.293 41.6941 302.143C35.0519 308.994 34.1732 316.187 34.2477 320.171",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M267.274 82.1481C267.274 82.1481 291.944 79.81 292.83 53.2191C293.641 29.0408 272.025 22.339 264.697 22.339C245.813 22.339 232.767 35.6382 231.606 52.2585C230.444 68.8787 242.306 75.6996 251.815 67.0916C261.324 58.4836 257.958 39.5401 255.583 30.6045C253.275 21.9742 246.305 7.62505 229.417 1.12439",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2333 174.885L81.8969 173.165L75.6643 162.792",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6494 162.792C75.6494 162.792 76.8334 158.6 81.2044 160.491",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8167 164.445C70.8167 164.445 66.3489 160.96 63.7278 167.997",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4422 205.571C72.6097 202.295 73.0022 198.793 72.589 195.34",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4619 203.427C63.5037 196.364 62.6399 189.15 59.96 182.532V182.532C62.7821 187.745 68.702 196.256 77.4663 196.256C90.1251 196.256 92.441 175.86 77.4663 147.11",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.509 136.566L222.171 129.812L217.286 101.993",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M106.403 277.652C102.375 281.479 97.8697 284.77 92.9994 287.444C82.3616 293.375 70.4039 296.537 58.225 296.64C42.0573 296.638 26.3842 291.065 13.8452 280.859C1.30617 270.653 -7.33271 256.437 -10.6166 240.607",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5618 225.014C65.483 225.014 66.2298 224.267 66.2298 223.346C66.2298 222.425 65.483 221.678 64.5618 221.678C63.6406 221.678 62.8938 222.425 62.8938 223.346C62.8938 224.267 63.6406 225.014 64.5618 225.014Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8391 266.788C54.7603 266.788 55.507 266.041 55.507 265.12C55.507 264.199 54.7603 263.452 53.8391 263.452C52.9179 263.452 52.1711 264.199 52.1711 265.12C52.1711 266.041 52.9179 266.788 53.8391 266.788Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4207 314.266C41.3419 314.266 42.0887 313.519 42.0887 312.598C42.0887 311.677 41.3419 310.93 40.4207 310.93C39.4995 310.93 38.7527 311.677 38.7527 312.598C38.7527 313.519 39.4995 314.266 40.4207 314.266Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2193 181.631C81.2193 181.631 74.5772 182.853 72.105 180.946",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7764 166.136C69.4797 166.136 70.0498 165.565 70.0498 164.862C70.0498 164.159 69.4797 163.589 68.7764 163.589C68.0732 163.589 67.5031 164.159 67.5031 164.862C67.5031 165.565 68.0732 166.136 68.7764 166.136Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1715 162.666C79.8748 162.666 80.4449 162.095 80.4449 161.392C80.4449 160.689 79.8748 160.119 79.1715 160.119C78.4683 160.119 77.8982 160.689 77.8982 161.392C77.8982 162.095 78.4683 162.666 79.1715 162.666Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M309.629 46.7333C309.629 46.7333 314.454 47.0758 316.107 45.6982",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M233.631 157.922C233.631 157.922 244.473 177.707 237.042 200.769C233.914 210.449 220.555 238.953 177.173 233.004C162.027 230.926 148.624 221.529 142.503 208.662C134.252 191.222 140.716 175.674 153.546 174.885C158.227 174.696 162.833 176.106 166.607 178.884",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M167.165 107.563C194.945 107.563 217.465 85.0424 217.465 57.2625C217.465 29.4825 194.945 6.96234 167.165 6.96234C139.385 6.96234 116.865 29.4825 116.865 57.2625C116.865 85.0424 139.385 107.563 167.165 107.563Z",
    stroke: "#B6B0CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHomePageIcon);
export default __webpack_public_path__ + "static/media/MobileHomePageIcon.f89d00cc4089890cea092c3bd8d56540.svg";
export { ForwardRef as ReactComponent };